import { Timestamp } from '@firebase/firestore-types';

export enum VogelAcademyVideoStatus {
    CANCELLED = 'cancelled',
    ERROR = 'error',
    PROCESSING = 'processing',
    READY = 'ready',
    UPLOADING = 'uploading',
}

export type VogelAcademyVideoQuality = 'basic' | 'plus';

export const vogelAcademyVideoStatusTranslation: Record<VogelAcademyVideoStatus, string> = {
    [VogelAcademyVideoStatus.CANCELLED]: 'Annulée',
    [VogelAcademyVideoStatus.ERROR]: 'Erreur',
    [VogelAcademyVideoStatus.PROCESSING]: 'Traitement',
    [VogelAcademyVideoStatus.READY]: 'Prête',
    [VogelAcademyVideoStatus.UPLOADING]: 'Import',
};

interface VogelAcademyVideoCore<D extends Timestamp | Date> {
    assetId?: string;
    createdAt: D;
    errorMessage?: string;
    eventDate: D;
    isPublished: boolean;
    playbackId?: string;
    status: VogelAcademyVideoStatus;
    title: string;
    updatedAt: D;
    uploadId: string;
    userId: string;
    videoQuality?: VogelAcademyVideoQuality;
}

export type VogelAcademyVideo = VogelAcademyVideoCore<Timestamp>;

export interface VogelAcademyVideoWithId extends VogelAcademyVideo {
    id: string;
}

export type VogelAcademyVideoRaw = VogelAcademyVideoCore<Date>;
